import { reactive } from 'vue';
import { getAppListByUserId, getDepartList, getAllApp, getAccessDenidedRoutes } from '@/service/meta-service';
import { getUserByLogin, getOfficialUserData as getOfficialUserDetails } from '@/service/admin-service';
import { getUserRights as getUserDataAdmin, getRouteListValidate, getRolesByApps } from '@/service/admin-service';
import { getRouteListChildren } from '@/service/admin-service';
import { getCookie } from '@/utils/cookies';

const state = reactive({
    allAppList: [],
    appList: [],
    depList: [],
    userData: {},
    officialData: {},
    userApps: [],
    userRights: [],
    userRightsUiRoute: [],
    userRightsUiChildObj: [],
    routePermission: null,
    currentUiRouteRight: {},
    currentUiRouteRightChildren: {},
    conteragentName: '',
    apps: [],
    departs: [],
    userGridFiltersValue: [],
    roleGridFiltersValue: [],
});

const disableUiElement = componentId => !state.userRightsUiChildObj.includes(componentId);

const getUserRights = async () => {
    const result = await getUserDataAdmin();
    if (result) {
        state.userRights = result.items;
        state.userRightsUiRoute = state.userRights?.filter(right => right.type === 'ui_route');
        state.userRightsUiChildObj = state.userRights
            ?.filter(right => right.type === 'ui_child_obj' && right.permission === 'W')
            .map(right => right.id);
    }
    return true;
};

const getRolesByAppsList = async () => {
    const result = await getRolesByApps();
    if (result) {
        state.userApps = result;
    }
};

async function checkAccess(routeName) {
    const token = getCookie('token');
    if (token) {
        let accessDeniedRoutes;
        if (state.userRights.length === 0) {
            await getUserRights();
        }

        accessDeniedRoutes = await getAccessDenidedRoutes(state.userRightsUiRoute);
        const route = accessDeniedRoutes.routes?.find(r => r.route_name === routeName);
        return route ? route.accessDenided : undefined;
    }
}

const removeEnvData = () => {
    state.userData = {};
    state.officialData = {};
    state.userRights = [];
    state.userRightsUiRoute = [];
    state.userRightsUiChildObj = [];
    state.routePermission = null;
    state.currentUiRouteRight = {};
    state.currentUiRouteRightChildren = {};
    state.apps = [];
    state.departs = [];
    state.userGridFiltersValue = [];
    state.roleGridFiltersValue = [];
};

const getUserData = async () => {
    const user = await getUserByLogin();
    if (user) {
        state.userData = user;
    }
    return user;
};

const getOfficialUserData = async () => {
    const official = state.userData.official_id && (await getOfficialUserDetails(state.userData.official_id));

    if (official) {
        state.officialData = official;
    }
    return official;
};

const getAppList = async () => {
    const response = await getAppListByUserId();

    if (response.result) {
        state.appList = response.items;
    }
    return true;
};

const getAllAppList = async () => {
    const response = await getAllApp();

    if (response.result) {
        state.allAppList = response.items;
    }
    return true;
};

const getDepList = async () => {
    const response = await getDepartList();

    if (response.result) {
        state.depList = response.items;
    }
    return true;
};

const getRoutePermission = async () => {
    const response = await getRouteListValidate();
    return (state.routePermission = response.success ? response.success : response.errors);
};

const setCurrentUiRouteRightByRoutePath = async routePath => {
    const trimmedRoutePath = routePath.split('&')[0];

    state.currentUiRouteRight = state.userRightsUiRoute.find(el => {
        const trimmedName = el.name.split('&')[0];
        return trimmedName === trimmedRoutePath;
    });
    if (state.currentUiRouteRight?.id) {
        state.currentUiRouteRightChildren = await getRouteListChildren(state.currentUiRouteRight.id);
    }
};

/*
Отделный метод, т.к. setCurrentUiRouteRightByRoutePath срабатывает поздно, и на момент маунта компонента данных еще нет в currentUiRouteRight
 */
const hasEditablePermission = (router) => {
    const path = router.currentRoute.value.path.split('&')[0];
    const page = state.userRightsUiRoute.find(x => x.name.split('&')[0] === path);
    return page?.permission === 'W';
}

export default {
    state,
    disableUiElement,
    getUserData,
    getRolesByAppsList,
    getOfficialUserData,
    getAppList,
    getAllAppList,
    getDepList,
    getUserRights,
    getRoutePermission,
    checkAccess,
    setCurrentUiRouteRightByRoutePath,
    removeEnvData,
    hasEditablePermission
};
